module.exports = __webpack_public_path__ + "img/C7.b1499ed9.png";